import moment from 'moment';

export const GUTTER = 10;
export const COL_SIZE = {
    xs: 18,
    sm: 19,
    md: 20,
};

export const COL_SIZE_PRICE = {
    xs: 6,
    sm: 5,
    md: 4,
};

const year = moment().year();

export const THEMES = {
    fa: {
        name: "fa",
        app: "ispx",
        org: "fa",
        favicon: "favicons/fa.ico",
        config: {
            en: {
                logos: {
                    header: "/logos/fibre-argenteil-logo-100-local.png",
                    footer: "/logos/100fibrelocale-white.png"
                },
                images: {
                    footer: "/images/footer2.png"
                },
                content: {
                    footer: `<p>Fibre Argenteuil © All rights reserved ${year} | <a href="https://fibreargenteuil.ca/en/acceptable-use-policy/" target="_blank">Acceptable Use Policy</a> | <a href="https://fibreargenteuil.ca/en/privacy-code/" target="_blank">Privacy Code</a> | <a href="https://fibreargenteuil.ca/en/terms-and-conditions/" target="_blank">Terms and Condition</a></p>`
                },
                address: {
                    small: "Lachute, Qc.",
                    big: "412, rue Principale"
                },
                timetable: {
                    first: {
                        small: "Monday to Friday",
                        big: "8h30 to 16h30"
                    },
                    second: null
                },
                contact: {
                    email: "support@fibreargenteuil.ca"
                }
            },
            fr: {
                logos: {
                    header: "/logos/fibre-argenteil-logo-100-local.png",
                    footer: "/logos/100fibrelocale-white.png"
                },
                images: {
                    footer: "/images/footer2.png"
                },
                content: {
                    footer: `<p>Fibre Argenteuil © Tous droits réservés ${year} | <a href="https://fibreargenteuil.ca/politique-dutilisation-acceptable/" target="_blank">Politique d'utilisation</a> | <a href="https://fibreargenteuil.ca/politique-de-confidentialite/" target="_blank">Politique de confidentialité</a> | <a href="https://fibreargenteuil.ca/termes-et-conditions/" target="_blank">Termes et conditions</a></p>`
                },
                address: {
                    small: "Lachute, Qc.",
                    big: "412, rue Principale"
                },
                timetable: {
                    first: {
                        small: "Lundi au Vendredi",
                        big: "8h30 à 16h30"
                    },
                    second: null
                },
                contact: {
                    email: "support@fibreargenteuil.ca"
                }
            }
        }
    },
    uptv: {
        name: "theme-uptv",
        app: "ispx",
        org: "uptv",
        favicon: "favicons/uptv.ico",
        config: {
            en: {
                logos: {
                    header: "/logos/logofrtran.png",
                    footer: "/logos/uptv3.png"
                },
                images: {
                    footer: ""
                },
                content: {
                    footer: "<p>© UpTélé inc. All rights reserved | <a href='http://www.uptele.com/fr/legal.php' target='_blank'>Terms and Condition of services</a></p>"
                },
                address: {
                    small: "Lachine, Qc.",
                    big: "300 Berges du canal #303"
                },
                timetable: {
                    first: {
                        small: "Monday to Friday",
                        big: "8h30 to 16h30"
                    },
                    second: null
                },
                contact: {
                    email: "support@uptele.com"
                }
            },
            fr: {
                logos: {
                    header: "/logos/logofrtran.png",
                    footer: "/logos/uptv3.png"
                },
                images: {
                    footer: ""
                },
                content: {
                    footer: "<p>© UpTélé inc. Tous droits réservés | <a href='http://www.uptele.com/fr/legal.php' target='_blank'>Termes et Condidtions des Services</a></p>"
                },
                address: {
                    small: "Lachine, Qc.",
                    big: "300 Berges du canal #303"
                },
                timetable: {
                    first: {
                        small: "Lundi au Vendredi",
                        big: "8h30 à 16h30"
                    },
                    second: null
                },
                contact: {
                    email: "support@uptele.com"
                }
            }
        }
    },
    cogir: {
        name: "theme-cogir",
        app: "ispx",
        org: "cogir",
        favicon: "favicons/cogir.png",
        config: {
            en: {
                logos: {
                    header: "/logos/cogir-en.png",
                    footer: "/logos/cogir.png"
                },
                images: {
                    footer: ""
                },
                content: {
                    footer: "<p>© Cogir. All rights reserved | <a href='http://www.uptele.com/fr/legal.php' target='_blank'>Terms and Condition of services</a></p>"
                },
                address: {
                    small: "Rivière-du-Loup, Qc.",
                    big: "65A Rue Iberville"
                },
                timetable: {
                    first: {
                        small: "Monday to Friday",
                        big: "8h to 17h"
                    },
                    second: null
                },
                contact: {
                    email: "support@rdltelecom.com",
                    phone: "418-868-6688"
                }
            },
            fr: {
                logos: {
                    header: "/logos/cogir-fr.png",
                    footer: "/logos/cogir.png"
                },
                images: {
                    footer: ""
                },
                content: {
                    footer: "<p>© Cogir. Tous droits réservés | <a href='http://www.uptele.com/fr/legal.php' target='_blank'>Termes et Condidtions des Services</a></p>"
                },
                address: {
                    small: "Rivière-du-Loup, Qc.",
                    big: "65A Rue Iberville"
                },
                timetable: {
                    first: {
                        small: "Lundi au Vendredi",
                        big: "8h à 17h"
                    },
                    second: null
                },
                contact: {
                    email: "support@rdltelecom.com",
                    phone: "418-868-6688"
                }
            }
        }
    },
    sjm: {
        name: "theme-sjm",
        app: "ispx",
        org: "sjm",
        favicon: "favicons/uptv.ico",
        config: {
            en: {
                logos: {
                    header: "/logos/sjm.png",
                    footer: "/logos/sjm.png"
                },
                images: {
                    footer: ""
                },
                content: {
                    footer: "<p>© Coop SJM inc. All rights reserved | <a href='http://www.uptele.com/fr/legal.php' target='_blank'>Terms and Condition of services</a></p>"
                },
                address: {
                    small: "Saint-Jacque-Le-Majeur, Qc. G0N 1E2",
                    big: "877 route 263"
                },
                timetable: {
                    first: {
                        small: "Monday to Friday",
                        big: "8h30 to 16h30"
                    },
                    second: null
                },
                contact: {
                    email: "sjmcoop@gmail.com",
                    phone: "514-316-0223"
                }
            },
            fr: {
                logos: {
                    header: "/logos/sjm.png",
                    footer: "/logos/sjm.png"
                },
                images: {
                    footer: ""
                },
                content: {
                    footer: "<p>© Coop SJM inc. Tous droits réservés | <a href='http://www.uptele.com/fr/legal.php' target='_blank'>Termes et Condidtions des Services</a></p>"
                },
                address: {
                    small: "Saint-Jacque-Le-Majeur, QC, G0N 1E2",
                    big: "877 route 263"
                },
                timetable: {
                    first: {
                        small: "Lundi au Vendredi",
                        big: "8h30 à 16h30"
                    },
                    second: null
                },
                contact: {
                    email: "sjmcoop@gmail.com",
                    phone: "514-316-0223"
                }
            }
        }
    },
    ispx: {
        name: "theme-uptv",
        app: "ispx",
        org: "ispx",
        favicon: "favicons/uptv.ico",
        config: {
            en: {
                logos: {
                    header: "/logos/logofrtran.png",
                    footer: "/logos/uptv3.png"
                },
                images: {
                    footer: ""
                },
                content: {
                    footer: "<p>© UpTélé inc. All rights reserved | <a href='http://www.uptele.com/fr/legal.php' target='_blank'>Terms and Condition of services</a></p>"
                },
                address: {
                    small: "Lachine, Qc.",
                    big: "300 Berges du canal #303"
                },
                timetable: {
                    first: {
                        small: "Monday to Friday",
                        big: "8h30 to 16h30"
                    },
                    second: null
                },
                contact: {
                    email: "support@uptele.com"
                }
            },
            fr: {
                logos: {
                    header: "/logos/logofrtran.png",
                    footer: "/logos/uptv3.png"
                },
                images: {
                    footer: ""
                },
                content: {
                    footer: "<p>© UpTélé inc. Tous droits réservés | <a href='http://www.uptele.com/fr/legal.php' target='_blank'>Termes et Condidtions des Services</a></p>"
                },
                address: {
                    small: "Lachine, Qc.",
                    big: "300 Berges du canal #303"
                },
                timetable: {
                    first: {
                        small: "Lundi au Vendredi",
                        big: "8h30 à 16h30"
                    },
                    second: null
                },
                contact: {
                    email: "support@uptele.com"
                }
            }
        }
    },
    centretess: {
        name: "theme-centretess",
        app: "ispx",
        org: "centretess",
        favicon: "favicons/uptv.ico",
        config: {
            en: {
                logos: {
                    header: "/logos/centre-tess-text.png",
                    footer: "/logos/centre-tess-text.png"
                },
                images: {
                    footer: ""
                },
                content: {
                    footer: "<p>© Centre TESS Inc. All rights reserved | <a href='http://www.uptele.com/fr/legal.php' target='_blank'>Terms and Condition of services</a></p>"
                },
                address: {
                    small: "Sainte-Agathe-Nord, Qc.",
                    big: "100 chemin de Mont Castor"
                },
                timetable: {
                    first: {
                        small: "Monday to Friday",
                        big: "9h to 17h"
                    },
                    second: null
                },
                contact: {
                    email: "info@centretess.com",
                    phone: "1-873-281-8377"
                }
            },
            fr: {
                logos: {
                    header: "/logos/centre-tess-text.png",
                    footer: "/logos/centre-tess-text.png"
                },
                images: {
                    footer: ""
                },
                content: {
                    footer: "<p>© Centre TESS Inc. Tous droits réservés | <a href='http://www.uptele.com/fr/legal.php' target='_blank'>Termes et Condidtions des Services</a></p>"
                },
                address: {
                    small: "Sainte-Agathe-Nord, Qc.",
                    big: "100 chemin de Mont Castor"
                },
                timetable: {
                    first: {
                        small: "Lundi au Vendredi",
                        big: "9h to 17h"
                    },
                    second: null
                },
                contact: {
                    email: "info@centretess.com",
                    phone: "1-873-281-8377"
                }
            }
        }
    },
    satelcom: {
        name: "theme-satelcom",
        app: "ispx",
        org: "satelcom",
        favicon: "favicons/uptv.ico",
        config: {
            en: {
                logos: {
                    header: "/logos/satelcom-retina.png",
                    footer: "/logos/satelcom-retina.png"
                },
                images: {
                    footer: ""
                },
                content: {
                    footer: "<p>© Satelcom Internet. All rights reserved | <a href='https://satelcom.ca/wp-content/uploads/2021/05/termes_et_conditions.pdf' target='_blank'>Terms and Condition of services</a></p>"
                },
                address: {
                    small: "Joliette, Qc.",
                    big: "713, boul. Manseau"
                },
                timetable: {
                    first: {
                        small: "Monday to Friday",
                        big: "8h to 17h"
                    },
                    second: null
                },
                contact: {
                    email: "info@satelcom.ca",
                    phone: "450 756-6162"
                }
            },
            fr: {
                logos: {
                    header: "/logos/satelcom-retina.png",
                    footer: "/logos/satelcom-retina.png"
                },
                images: {
                    footer: ""
                },
                content: {
                    footer: "<p>© Satelcom Internet. Tous droits réservés | <a href='https://satelcom.ca/wp-content/uploads/2021/05/termes_et_conditions.pdf' target='_blank'>Termes et Condidtions des Services</a></p>"
                },
                address: {
                    small: "Joliette, Qc.",
                    big: "713, boul. Manseau"
                },
                timetable: {
                    first: {
                        small: "Lundi au Vendredi",
                        big: "8h to 17h"
                    },
                    second: null
                },
                contact: {
                    email: "info@satelcom.ca",
                    phone: "450 756-6162"
                }
            }
        }
    },
    ctal: {
        name: "theme-ctal",
        app: "ispx",
        org: "ctal",
        favicon: "favicons/ctal.ico",
        config: {
            en: {
                logos: {
                    header: "/logos/ctal-white.png",
                    footer: "/logos/ctal.png"
                },
                hasDataProtetionAccept: true,
                images: {
                    footer: ""
                },
                content: {
                    footer: "<p>© Coopérative de télécommunication d'Antoine-Labelle. All rights reserved | <a href='https://ctal.ca/en/privacy-policies/' target='_blank'>Terms and Condition of services</a></p>"
                },
                address: {
                    small: "Bureau 203, Mont-Laurier, Qc. J9L 1L4",
                    big: "600, boulevard Albiny-Paquette"
                },
                timetable: {
                    first: {
                        small: "Monday to Friday",
                        big: "9h00 to 17h00"
                    },
                    second: null
                },
                contact: {
                    email: "info@ctal.ca",
                    phone: "819-623-2825"
                }
            },
            fr: {
                logos: {
                    header: "/logos/ctal-white.png",
                    footer: "/logos/ctal.png"
                },
                hasDataProtetionAccept: true,
                images: {
                    footer: ""
                },
                content: {
                    footer: "<p>© Coopérative de télécommunication d'Antoine-Labelle. Tous droits réservés | <a href='https://ctal.ca/conditionsdutilisation/' target='_blank'>Termes et Condidtions des Services</a></p>"
                },
                address: {
                    small: "Bureau 203, Mont-Laurier, Qc. J9L 1L4",
                    big: "600, boulevard Albiny-Paquette"
                },
                timetable: {
                    first: {
                        small: "Lundi au Vendredi",
                        big: "9h00 à 17h00"
                    },
                    second: null
                },
                contact: {
                    email: "info@ctal.ca",
                    phone: "819-623-2825"
                }
            }
        }
    },
    tflm: {
        name: "theme-tflm",
        app: "ispx",
        org: "tflm",
        favicon: "favicons/tflm.ico",
        config: {
            en: {
                logos: {
                    header: "/logos/tflm.png",
                    footer: "/logos/tflm-white.png"
                },
                hasDataProtetionAccept: false,
                images: {
                    footer: ""
                },
                content: {
                    footer: `<p>© ${year} - TFLM - All rights reserved | <a href="https://telefibrelaminerve.com/en/conditions-of-use/">Acceptable use policy</a> | <a href="https://telefibrelaminerve.com/en/privacy-policy/">Privacy policy</a> | <a href="https://telefibrelaminerve.com/en/obligations-and-general-terms-of-subscription/">Terms and conditions</a></p>`
                },
                address: {
                    small: "La Minerve, Qc. J0T 1S0",
                    big: "132, Chemin des Fondateurs"
                },
                timetable: {
                    first: {
                        small: "Monday to Friday",
                        big: "8h30 to 16h00"
                    },
                    second: null
                },
                contact: {
                    email: "information@telefibrelaminerve.com",
                    phone: "819-274-1553"
                }
            },
            fr: {
                logos: {
                    header: "/logos/tflm.png",
                    footer: "/logos/tflm-white.png"
                },
                hasDataProtetionAccept: false,
                images: {
                    footer: ""
                },
                content: {
                    footer: `<p>© ${year} - TFLM - Tous droits réservés | <a href="https://telefibrelaminerve.com/conditions-dutilisation/">Politique d'utilisation</a> | <a href="https://telefibrelaminerve.com/politique-de-confidentialite/">Politique de confidentialité</a> | <a href="https://telefibrelaminerve.com/obligations-et-conditions-generales-dabonnement/">Termes et conditions</a></p>`
                },
                address: {
                    small: "La Minerve, Qc. J0T 1S0",
                    big: "132, Chemin des Fondateurs"
                },
                timetable: {
                    first: {
                        small: "Lundi au Vendredi",
                        big: "8h30 à 16h00"
                    },
                    second: null
                },
                contact: {
                    email: "information@telefibrelaminerve.com",
                    phone: "819-274-1553"
                }
            }
        }
    }
};
